import md5 from 'md5';
// 签名密钥串(前后端要一致，正式发布请自行修改)
const signatureSecret = 'dd05f1c54d63749eda95f9fa6d49v442a';

export default class signMd5Utils {
    /**
     * json参数升序
     * @param jsonObj 发送参数
     */

    static sortAsc(jsonObj) {
        const arr = [];
        let num = 0;
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const i in jsonObj) {
            arr[num] = i;
            // eslint-disable-next-line no-plusplus
            num++;
        }
        const sortArr = arr.sort();
        const sortObj = {};
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const i in sortArr) {
            sortObj[sortArr[i]] = jsonObj[sortArr[i]];
        }
        return sortObj;
    }

    /**
     * @param url 请求的url,应该包含请求参数(url的?后面的参数)
     * @param requestParams 请求参数(POST的JSON参数)
     * @returns {string} 获取签名
     */
    static getSign(url, requestParams) {
        const urlParams = this.parseQueryString(url);
        const jsonObj = this.mergeObject(urlParams, requestParams);
        const requestBody = this.sortAsc(jsonObj);
        return md5(JSON.stringify(requestBody) + signatureSecret).toUpperCase();
    }

    /**
     * @param url 请求的url
     * @returns {{}} 将url中请求参数组装成json对象(url的?后面的参数)
     */
    static parseQueryString(url) {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        const urlReg = /^[^?]+\?([\w\W]+)$/;
        const paramReg = /([^&=]+)=([\w\W]*?)(&|$|#)/g;
        const urlArray = urlReg.exec(url);
        const result = {};

        // 获取URL上最后带逗号的参数变量 sys/dict/getDictItems/sys_user,realname,username
        // 【这边条件没有encode】带条件参数例子：/sys/dict/getDictItems/sys_user,realname,id,username!='admin'%20order%20by%20create_time
        let lastpathVariable = url.substring(url.lastIndexOf('/') + 1);
        if (lastpathVariable.includes(',')) {
            if (lastpathVariable.includes('?')) {
                lastpathVariable = lastpathVariable.substring(0, lastpathVariable.indexOf('?'));
            }
            // 解决Sign 签名校验失败 #2728
            result['x-path-variable'] = decodeURI(lastpathVariable);
        }
        if (urlArray && urlArray[1]) {
            const paramString = urlArray[1];
            let paramResult;
            // eslint-disable-next-line no-cond-assign
            while ((paramResult = paramReg.exec(paramString)) != null) {
                // 数字值转为string类型，前后端加密规则保持一致
                if (this.myIsNaN(paramResult[2])) {
                    paramResult[2] = paramResult[2].toString();
                }
                // eslint-disable-next-line prefer-destructuring
                result[paramResult[1]] = paramResult[2];
            }
        }
        return result;
    }

    /**
     * @returns {*} 将两个对象合并成一个
     */
    static mergeObject(objectOne, objectTwo) {
        if (objectTwo && Object.keys(objectTwo).length > 0) {
            // eslint-disable-next-line no-restricted-syntax
            for (const key in objectTwo) {
                // eslint-disable-next-line no-prototype-builtins
                if (objectTwo.hasOwnProperty(key) === true) {
                    // 数字值转为string类型，前后端加密规则保持一致
                    if (this.myIsNaN(objectTwo[key])) {
                        objectTwo[key] = objectTwo[key].toString();
                    }
                    objectOne[key] = objectTwo[key];
                }
            }
        }
        return objectOne;
    }

    static urlEncode(param, key, encode) {
        if (param == null) return '';
        let paramStr = '';
        const t = typeof param;
        if (['string', 'number', 'boolean'].includes(t)) {
            paramStr += `&${key}=${encode == null || encode ? encodeURIComponent(param) : param}`;
        } else {
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            for (const i in param) {
                const k = key == null ? i : key + (param instanceof Array ? `[${i}]` : `.${i}`);
                paramStr += this.urlEncode(param[i], k, encode);
            }
        }
        return paramStr;
    }

    static getDateTimeToString() {
        const date_ = new Date();
        const year = date_.getFullYear();
        let month = date_.getMonth() + 1;
        let day = date_.getDate();
        if (month < 10) month = `0${month}`;
        if (day < 10) day = `0${day}`;
        let hours = date_.getHours();
        let mins = date_.getMinutes();
        let secs = date_.getSeconds();
        const msecs = date_.getMilliseconds();
        if (hours < 10) hours = `0${hours}`;
        if (mins < 10) mins = `0${mins}`;
        if (secs < 10) secs = `0${secs}`;
        if (msecs < 10) secs = `0${msecs}`;
        return `${year}${month}${day}${hours}${mins}${secs}`;
    }

    static getDateTimeToStringDiff(timeDifference) {
        return new Date().getTime() + Number(timeDifference);
    }

    // true:数值型的，false：非数值型
    static myIsNaN(value) {
        // eslint-disable-next-line no-restricted-globals
        return typeof value === 'number' && !isNaN(value);
    }
}
